import React, {Component} from "react"
import PropTypes from "prop-types"

import {IconLabel} from "~/components/"

export default class BooleanField extends Component {
  static contextTypes = {
    onChange: PropTypes.func,
    getInitialValue: PropTypes.func
  }

  constructor(props, context) {
    super(props)
    this.state = {
      value: context.getInitialValue
        ? context.getInitialValue(this.props.name)
        : false
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(event) {
    this.setState(state => {
      const newValue = !state.value
      if (this.context.onChange) {
        this.context.onChange(this.props.name, newValue)
      }
      if (this.props.onChange) {
        this.props.onChange(newValue)
      }
      return {
        value: newValue
      }
    })
  }

  render() {
    const value = this.props.value || this.state.value
    return (
      <label
        className={`sh-field-boolean ${this.props.disabled && "disabled"}`}
        htmlFor={this.props.name}
        onClick={!this.props.disabled && this.handleClick}
      >
        <span>{this.props.label}</span>
        <div className="inner">
          <IconLabel i={value ? "check-circle-o" : "circle-o"}>
            {this.props.description}
          </IconLabel>
          <p>{this.props.children}</p>
        </div>
      </label>
    )
  }
}

BooleanField.propTypes = {
  value: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/fields/BooleanField.js